export const types = {
  // default: 'Note',
  vulnerable_customer: 'Vulnerable customer',
  particularly_vulnerable_customer: 'Particularly vulnerable customer',
  complaint: 'Complaint',
  refund_request: 'Refund request',
  technical_error: 'Technical error',
  covid_19_freeze_request: 'Covid-19 freeze request',
  pre_arrears: 'Pre-arrears',
  in_arrears: 'In arrears',
  at_risk_of_default: 'At risk of default',
  defaulted: 'Defaulted',
  breathing_space: 'Breathing space',
  promise_to_pay: 'Promise to pay',
  payment_freeze: 'Payment freeze',
  reduced_payment_plan: 'Reduced payment plan',
  adhoc_payment_plan: 'Ad-hoc payment plan',
  iva: 'IVA',
  dissatisfaction: 'Dissatisfaction',
  financial_ombudsman: 'Financial Ombudsman',
  bankruptcy: 'Bankruptcy',
  finance_manual_review: 'Finance manual review',
  merchant_manual_review: 'Merchant manual review',
  merchant_quarterly_call: 'Merchant quarterly call',
  finance_review_document: 'Finance review document',
  merchant_monthly_report: 'Merchant monthly report',
  merchant_fca_report: 'Merchant FCA report',
  merchant_follow_up: 'Merchant follow up',
  merchant_leads_sale: 'Merchant leads sale',
  merchant_leads_campaign: 'Merchant leads campaign',
  merchant_leads_fee: 'Merchant leads fee',
  deceased: 'Deceased',
  finance_management_approval: 'Management approval required',
  merchant_compliance_review: 'Merchant compliance review',
  insolvency: 'Insolvency',
  switch_payment_plan: 'Switch payment plan',
  clinician_status_change: 'Clinician status change',
  finance_follow_up: 'Finance follow up',
  dmc_reduced_plan: 'DMC Reduced Plan',
  write_off: 'Write Off',
  dca: 'DCA',
  general_enquiry: 'General Enquiry',
  third_party_authority: '3rd Party Authority',
  failed_check: 'Failed check',
  incorrect_credit_reporting_fully_repaid:
    'Incorrect Credit Reporting (Fully Repaid)',
  incorrect_credit_reporting_open_balance:
    'Incorrect Credit Reporting (Open Balance)',
  personal_details_update: 'Personal Details Update',
  money_claim: 'Money Claim',
  fraud_case: 'Fraud Case',
  insolvency_write_off: 'Insolvency Write-Off',
  payout_frozen: 'Payout frozen',
}

export const get = value => {
  if (value === 'default') {
    return null
  }

  return types[value] || value
}

export const tableTagFilterLoad = query =>
  Object.entries({ ...types, default: 'No type' })
    .map(([value, label]) => ({ value, label }))
    .filter(({ label }) => label.toLowerCase().includes(query.toLowerCase()))

export const load = query =>
  Object.entries(types)
    .map(([value, label]) => ({ value, label }))
    .filter(({ label }) => label.toLowerCase().includes(query.toLowerCase()))

export const autoValuesByType = {
  vulnerable_customer: {
    title: 'Vulnerable customer',
    isStarred: true,
  },
  particularly_vulnerable_customer: {
    title: 'Particularly vulnerable customer',
    isStarred: true,
  },
  complaint: {
    isStarred: true,
  },
  deceased: {
    title: 'Consumer is deceased',
    isStarred: true,
  },
  refund_request: {
    title: 'Refund request',
  },
  covid_19_freeze_request: {
    title: 'Requested payment holiday due to Covid-19',
  },
  pre_arrears: { title: 'Collections case' },
  in_arrears: { title: 'Collections case' },
  at_risk_of_default: { title: 'Collections case' },
  defaulted: { title: 'Collections case' },
  breathing_space: { title: 'Collections case' },
  promise_to_pay: { title: 'Collections case' },
  insolvency: { title: 'Collections case' },
  finance_manual_review: {
    title: 'Consumer in Manual Review',
  },
  merchant_manual_review: {
    title: 'Merchant in Manual Review',
  },
  merchant_quarterly_call: {
    title: 'Quarterly call',
  },
  finance_review_document: {
    title: 'Check manual review document',
  },
  finance_follow_up: {
    title: 'Application not started',
  },
  iva: {
    title: 'Consumer entered an individual voluntary arrangement (IVA)',
  },
  dissatisfaction: {
    title: 'Expressed dissatisfaction',
  },
  financial_ombudsman: {
    title: 'Report to the Financial Ombudsman Service (FOS)',
  },
  bankruptcy: {
    title: 'Filed for bankruptcy',
  },
  merchant_compliance_review: {
    title: 'Compliance review',
  },
  merchant_monthly_report: {
    title: 'Send out monthly report',
  },
  merchant_fca_report: {
    title: 'Complete FCA report',
    description: `Please enter data in this Google Form. Thanks
https://docs.google.com/forms/d/e/1FAIpQLScuDj09nKrUFygBM8uQJo0UpCRgZ6bG5aUOCztQ0ZBXGwx9yw/viewform`,
  },
  merchant_follow_up: {
    title: 'Follow-up',
  },
  merchant_leads_sale: {
    title: 'Leads sale',
    description: `Treatment type: [aligner, implants, whitening] 
Trading full address: Postcode(s) for marketing: [SW5, SW4, ...]
Radius: [3] miles`,
  },
  merchant_leads_campaign: {
    title: 'Leads campaign',
    description: `Treatment type: [aligner / implant / other]
Price: £[1,000] and [...] over [60] months 
Google: [Yes / No] Facebook: [Yes / No] 
Calendly link: [Yes - [link] / No] 
Other booking link: [link]`,
  },
  payout_frozen: {
    title: 'Payout frozen',
    description:
      'This transaction is excluded from payout while under review. The payout will be released once this ticket has been resolved.',
    isStarred: true,
  },
  merchant_leads_fee: {
    title: 'Leads fee collection',
    description: `DocuSign: [signed / pending] 
GC for Tabeo fee: [pending / set up] 
GC for ads: [pending / set up] 
Adhoc for ads: £[...] collected via bills or pay now`,
  },
}

export const forcedValuesByType = {
  vulnerable_customer: {
    isStarred: true,
  },
  particularly_vulnerable_customer: {
    isStarred: true,
  },
  deceased: {
    isStarred: true,
  },
  payout_frozen: {
    isStarred: true,
  },
}

export const ticketTypeConfigs = {
  vulnerable_customer: {
    isStarHidden: true,
  },
  particularly_vulnerable_customer: {
    isStarHidden: true,
  },
  deceased: {
    isStarHidden: true,
  },
  switch_payment_plan: {
    isDeleteHidden: true,
  },
  payout_frozen: {
    isStarHidden: true,
    isDeleteHidden: true,
  },
}
